<template>
  <ipo3-page>
    <template slot="title">爬蟲清單</template>
    <template slot="tools">
      <el-input v-model="form.title" style="width:200px;margin-right:10px;" placeholder="請輸入標題"></el-input>
      <el-date-picker
      v-model="form.date"
      type="daterange"
      range-separator="至"
      start-placeholder="開始日期"
      end-placeholder="結束日期" style="margin-right:10px;">
    </el-date-picker>
      <el-select v-model="form.source" placeholder="請選擇來源" style="margin-right:10px;">
              <el-option
                v-for="item in sources"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
      </el-select>
      
      <el-button icon="el-icon-edit" @click="onSearch" type="primary">搜索</el-button>
    </template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <template v-for="item in items">
            <el-table-column
              :key="item.name"
              v-if="item.id==='image'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                <img :src="scope.row.image" width="100" height="100" />
              </template>
            </el-table-column>

            <el-table-column
              :key="item.name"
              v-else-if="item.scope==='time'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                  {{scope.row.update_at|formDate(true)}}
               </template>
            </el-table-column>

            <el-table-column
              v-else
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row.id, 0)"
                  size="mini"
                  type="success"
                  v-if="scope.row.status==0"
                >審核</el-button>
                <el-button
                  @click="onDelete(scope.row)"
                  size="mini"
                  type="danger"
                >查看</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
      <language-dialog ref="languageDialog" @sucess="onSucess"></language-dialog>
    </template>
  </ipo3-page>
</template>
<script>
import languageDialog from "./dialogs/language_dialog";
export default {
  name: "news-index",
  components: { languageDialog },
  data() {
    return {
      tableData: [],
      isLoading: false,
      form:{
        source:'',
        title:'',
        date:''
      },
      sources:[
        {
          name:'全部',
          value:''
        },
        {
          name:'HK01',
          value:'hk01'
        },
        {
          name:'香港經濟日報',
          value:'hket',
        },
        {
          name:'大紀元',
          value:'epochtimes',
        },
        {
          name:'東網',
          value:'hkon'
        },
        {
          name:'now 新聞',
          value:'now-news'
        },
        {
          name:'明報新聞網',
          value:'mingpao'
        },
        {
          name:'AM730',
          value:'am730'
        },
        {
          name:'星島網',
          value:'stheadline'
        },
        {
          name:'雅虎香港新聞',
          value:'yahoo'
        },
        {
          name:'巴士的報',
          value:'bastillepost'
        },
        {
          name:'香港電台',
          value:'rthk'
        }
      ],
      getRowClass: {
        background: "#F2F2F2"
      },
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "title" },
        { name: "來源", id: "source" },
        { name: "狀態", id: "status_txt" },
        { name: "時間", id: "update_at",scope:'time' },
      ],
      currentPage: 1,
      pagecount: 1,
      paginate: 20
    };
  },
  created(){
      let params = this.$route.query;
      this.currentPage = params.page||1;
      this.paginate = params.size||10;
      this.getData(this.currentPage,this.paginate);
  },
  methods:{
      getData(page=1,size=20){
        let params = this.form;
        if(params.date)
        {
          params.start_time = params.date[0].getTime()/1000;
          params.end_time = params.date[1].getTime()/1000;
        }else{
          params.start_time =0;
          params.end_time = 0;
        }

          let self = this;
          this.$http.get("/admin/crawler/index",{page:page,size:size,...params}).then(res=>{
            let {data,total} = res.data;
            self.pagecount = total;
            self.tableData =  data;
          })
      },
      onSearch(){
        this.currentPage = 0;
        this.paginate = 10;
        let params = Object.assign({},this.form);
        delete params.date;
        this.$router.push({path:'/reptile/index',query:{page:this.currentPage,size:this.paginate,...params}});
        this.getData();
      },
      
      onHandle(index,id)
      {
          //this.$refs.languageDialog.show(id);
          this.$router.push({path:`/reptile/edit/${id}?language=tw`})
      },
      handleSizeChange(size)
      {
        this.paginate = size;
        this.getData(1,size);
      },

      handleCurrentChange(val)
      {
        let params = Object.assign({},this.form);
        delete params.date;
        this.$router.push({path:'/reptile/index',query:{page:val,size:this.paginate,...params}})
        this.getData(val,this.paginate);
      },
      onDelete(val)
      {
        window.open(val.href,'_blank');
        // window.location.href = val.href;
      }
  }
};
</script>